import { Investor } from 'src/app/domain/investors-and-net-irr/dto/InvestorContribution';
import { InvestorCapitalAccount } from '../../capital-account/InvestorCapitalAccount';

export class InvestorCapitalAccountDTO {
  public uuid: string;
  public code: string;
  public name: string;
  public isGP = false;
  public commitment: number;

  constructor(
    uuid: string,
    code: string,
    name: string,
    isGP: boolean,
    commitment: number,
  ) {
    this.uuid = uuid;
    this.code = code;
    this.name = name;
    this.isGP = isGP;
    this.commitment = commitment;
  }

  static toInvestorCapitalAccount(dto: InvestorCapitalAccountDTO): InvestorCapitalAccount {
    return new InvestorCapitalAccount(
      dto.uuid,
      dto.code,
      dto.name,
      dto.isGP,
      dto.commitment,
    );
  }

  static arrayToInvestorCapitalAccountArray(dtos: InvestorCapitalAccountDTO[]): InvestorCapitalAccount[] {
    return dtos.map((dto) => InvestorCapitalAccountDTO.toInvestorCapitalAccount(dto));
  }

  /**
   * Creates an instance of InvestorCapitalAccountDTO from an Investor object.
   *
   * **Important Note:** The `uuid` property of the created InvestorCapitalAccountDTO will be `null`,
   * as the investors are being saved as new CapitalAccountInvestors.
   */
  static fromInvestor(investor: Investor): InvestorCapitalAccountDTO {
    return new InvestorCapitalAccountDTO(
      null,
      investor.code,
      investor.name,
      investor.isGP,
      investor.tracker.commitment ?? 0,
    );
  }

  static fromInvestorArray(investors: Investor[]): InvestorCapitalAccountDTO[] {
    return investors.map((investor) => InvestorCapitalAccountDTO.fromInvestor(investor));
  }
}
